var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c("avue-crud", {
        ref: "crud",
        attrs: {
          option: _vm.option,
          "table-loading": _vm.loading,
          data: _vm.data,
        },
        on: {
          "search-change": _vm.searchChange,
          "search-reset": _vm.searchReset,
          "selection-change": _vm.selectionChange,
          "current-change": _vm.currentChange,
          "size-change": _vm.sizeChange,
          "refresh-change": _vm.refreshChange,
          "on-load": _vm.onLoad,
        },
        scopedSlots: _vm._u([
          {
            key: "menu",
            fn: function (scope) {
              return [
                _vm.permission.work_claim_sign
                  ? _c(
                      "el-button",
                      {
                        staticClass: "none-border",
                        attrs: { type: "text", size: "small", plain: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleClaim(scope.row)
                          },
                        },
                      },
                      [_vm._v("签收\n      ")]
                    )
                  : _vm._e(),
                _vm.permission.work_claim_detail
                  ? _c(
                      "el-button",
                      {
                        staticClass: "none-border",
                        attrs: { type: "text", size: "small", plain: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情\n      ")]
                    )
                  : _vm._e(),
                _vm.permission.work_claim_follow
                  ? _c(
                      "el-button",
                      {
                        staticClass: "none-border",
                        attrs: { type: "text", size: "small", plain: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleImage(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("跟踪\n      ")]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "processDefinitionVersion",
            fn: function ({ row }) {
              return [
                _c("el-tag", [
                  _vm._v("v" + _vm._s(row.processDefinitionVersion)),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.form,
          callback: function ($$v) {
            _vm.form = $$v
          },
          expression: "form",
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "流程图",
            "append-to-body": "",
            visible: _vm.flowBox,
            fullscreen: true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.flowBox = $event
            },
          },
        },
        [
          _c("iframe", {
            attrs: {
              src: _vm.flowUrl,
              width: "100%",
              height: "700",
              title: "流程图",
              frameBorder: "no",
              border: "0",
              marginWidth: "0",
              marginHeight: "0",
              scrolling: "no",
              allowTransparency: "yes",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.flowBox = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }